import { pathOr } from 'ramda';
import SiteSettings from 'src/siteSetting';

////////
export const APP_ROOT = pathOr('', ['origin'], location);

export const LOG_OUT = '/logout';
export const BASE_ROOT = "/"
export const LOGIN_ROOT = '/login';
export const DEFAULT_HOME_ROOT =  '/getstarted'

export const HOME_ROOT = SiteSettings.generalHomeRoot() ||
    DEFAULT_HOME_ROOT;


//// BASE
const USERS_BASE_ROUTE = `/loans/manage/users`;
const BASE_APPLICATION_ROUTE = `/loans/manage/applications`;
export const APPLICATIONS_CHECK_ROUTE = `/loans/manage/check`;

export const surveyLoanApplicationRoute = (loanId: string, loanRoleId: string) => `${BASE_APPLICATION_ROUTE}/${loanId}/r/${loanRoleId}`;
export const surveyBaseLoanApplicationRoute = (loanId: string) => `${BASE_APPLICATION_ROUTE}/${loanId}`;

//// Applications
export const OAUTH_CALLBACK = '/oauth/callback';

export const oauthCallBackReturnTo = (returnTo: string) => `${OAUTH_CALLBACK}?returnTo=${returnTo}`

export const ADVISOR_LANDING = '/internal/d'

///// Advisor Dashboard
export const ADVISOR_DASHBOAD = `${ADVISOR_LANDING}?thisurl=Applications`;

export const USERS_HOME = '/loans/all'


export const PASSWORD_UPDATE_ROUTE = '/change_password'


export const START_APPLICATION_HOME = '/loans/manage';

export const START_APPLICATION_AUTH = '/loans/auth';

export const RAILZ_ROUTE = `${START_APPLICATION_HOME}/railz/completed`;

export const ALL_NOTIFICATIONS_ROUTE = `${ADVISOR_LANDING}notifications?thisurl=Notifications`

////// Users Dashboard
export const USER_WORKS_BASE_ROUTE = `${USERS_BASE_ROUTE}/works`;
export const USERS_OVERVIEW_BASE_ROUTE = `${USERS_BASE_ROUTE}/overview?thisurl=Overview`;
export const USERS_APPLICAION_WORKSPACE_BASE_ROUTE = `${USERS_BASE_ROUTE}/application?thisurl=Application`;
export const USERS_DOCUMENTS_BASE_ROUTE = `${USERS_BASE_ROUTE}/documents`;
export const USERS_LOCKRATE_BASE_ROUTE = `${USERS_BASE_ROUTE}/lockrate`;
export const USERS_E_DISCLOSURE_BASE_LOGIN_ROUTE = `${USERS_BASE_ROUTE}/edisclosure/login`;
export const USERS_E_DISCLOSURE_BASE_VIEW_ROUTE = `${USERS_BASE_ROUTE}/edisclosures`;
export const USERS_DASHBOARD_BASE_ROUTE = `${USERS_BASE_ROUTE}/dashboard`;
export const USERS_WORKS_ROUTE = `${USERS_BASE_ROUTE}/works?thisurl=Tasks`;
export const USERS_CHAT_ROUTE = `${USERS_BASE_ROUTE}/chat?thisurl=Chat`
export const USERS_START_NEW_APPLICATION = `/loans/all?view=myapps`

export const START_APPLYING = 'startapplying';

export const PASSWORDLESS_ROUTE = `/${START_APPLYING}`;
export const START_NEW_APPLICATION_ROUTE = '/startnew';
export const FORGOT_URL = '/u/forgot_password';
